/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll("table").forEach(this.#formatTable);
    this.querySelectorAll("a").forEach(this.#formatVideoLinks);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("rte-table-wrapper");
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  /**
   * Formats video links to match the reply-video-button design
   * ToDo: Check for replacement with new SVG usage in snippets/reply-video-button.liquid
   * @param {HTMLAnchorElement} link
   */
  #formatVideoLinks(link) {
    const isVideo =
      link.dataset.videoTrigger !== undefined ||
      link.href.includes("youtube.com/embed/") ||
      link.href.includes("youtube.com/watch") ||
      link.href.includes("youtu.be/");

    if (isVideo && !link.classList.contains("ni-video-button")) {
      const labelText = link.textContent.trim();
      link.classList.add("ni-video-button");
      link.innerHTML = `
        <img class="ni-video-button__icon reply-media-action-btn__icon svg-wrapper" src="/cdn/shop/t/4/assets/ni-icon-play.svg?v=4185201757242190801769516667" alt="" aria-hidden="true" width="40" height="40" loading="lazy">
        <span class="ni-video-button__label reply-media-action-btn__label">${labelText}</span>
      `;
    }
  }
}

if (!customElements.get("rte-formatter")) {
  customElements.define("rte-formatter", RTEFormatter);
}
